import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState, memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { ActDomainManagmentFiltersForm } from 'civil-status/view-models/act-domain-managment-list';

interface DomainManagementFiltersProps {
  filterDomainManagementForm: FormikProps<ActDomainManagmentFiltersForm>;
}

const DomainManagementFiltersComponent = ({
  filterDomainManagementForm,
}: DomainManagementFiltersProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-groups-content"
        id="panel-groups-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterDomainManagementForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Tipo Dominio"
                label="Tipo Dominio"
                id="domainType"
                name="domainType"
                fullWidth
                type="text"
                variant="outlined"
                value={filterDomainManagementForm.values?.domainType || ''}
                onChange={(e) =>
                  filterDomainManagementForm.setFieldValue('domainType', e.target.value)
                }
                onBlur={() => filterDomainManagementForm.setFieldTouched('domainType', true)}
                error={
                  filterDomainManagementForm.touched.domainType &&
                  Boolean(filterDomainManagementForm.errors.domainType)
                }
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <PmiTextField
                aria-label="Nome Dominio"
                label="Nome Dominio"
                id="domainName"
                name="domainName"
                fullWidth
                type="text"
                variant="outlined"
                inputProps={{
                  maxLength: '250',
                }}
                value={filterDomainManagementForm.values?.domainName || ''}
                onChange={(e) =>
                  filterDomainManagementForm.setFieldValue('domainName', e.target.value)
                }
                onBlur={() => filterDomainManagementForm.setFieldTouched('domainName', true)}
                error={
                  filterDomainManagementForm.touched.domainName &&
                  Boolean(filterDomainManagementForm.errors.domainName)
                }
              />
            </Grid>

            <Grid item xs={12} md={1}>
              <PmiButton
                fullWidth
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterDomainManagementForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

DomainManagementFiltersComponent.displayName = 'Domain Management Filters Component';

const DomainManagementFilters = memo(DomainManagementFiltersComponent);

export default DomainManagementFilters;
